import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import NotificationService from '@services/NotificationService/NotificationService';
import ModalPopup from '@components/ModalPopup';
import DocumentHelper from '../../helpers/DocumentHelper';
import HttpClient from '@services/REST/HttpClient';
import { Subscription } from 'rxjs';
import store from 'store';
import moment from 'moment';
import Parser from 'html-react-parser';
import '@views/Notifications/style.scss';

class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.subscriptions = new Subscription();

        this.state = {
            open: false,
            notifications: []
        }

        this.toggle = this.toggle.bind(this);
        this.toggleKeyup = this.toggleKeyup.bind(this);
        this.onDropdownClick = this.onDropdownClick.bind(this);
        this.onDropdownClickKeyup = this.onDropdownClickKeyup.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        window.addEventListener("storage", (function (e) {
            if (store.get('notification_count') != this.state.notifications.length || store.get('unread_notification_count') != this.state.notifications.filter(not => !not.seen).length) this.refresh()
        }).bind(this));

        NotificationService.unreadNotifications.subscribe(val => {
            if (val !== this.state.notifications.filter(not => !not.seen).length) this.refresh();
        })

        NotificationService.totalNotifications.subscribe(val => {
            if (val !== this.state.notifications.length) this.refresh();
        })

        this.refresh();
        document.addEventListener('click', this.closeDropdown);
    }

    refresh() {
        let url = '/marketing-notices/unseen/';

        this.subscriptions.add(
            HttpClient.get(url).subscribe(resp => {
                this.setState(prevState => {
                    prevState.notifications = resp.data.notifications;
                    store.set('notification_count', prevState.notifications.length);
                    store.set('unread_notification_count', this.state.notifications.filter(not => !not.seen).length);
                    NotificationService.setTotalNotifications(prevState.notifications.length);
                    NotificationService.setUnread(prevState.notifications.filter(not => !not.seen).length);
                    return prevState
                });
            }, error => {

            })
        );
    }
    markAsRead(id) {
        // const is_seen = this.state.notifications.filter(not => not.id === id)[0].seen;
        // if (is_seen) return;
        let url = '/marketing-notices/' + id + '/seen/';

        this.subscriptions.add(
            HttpClient.post(url).subscribe(resp => {
                this.refresh();
            }, error => {

            })
        );
    }

    closeDropdown(e) {
        const trg = e.target;
        const cls = 'global-notifications-dropdown';

        if (trg.classList.contains(cls) || trg.classList.contains('open-notifications') || DocumentHelper.closest(trg, '.' + cls)) return;
        else this.setState({ open: false });
    }

    toggle() {
        this.setState({ open: !this.state.open });
    }

    toggleKeyup(e) {
        if (e.keyCode === 13) this.toggle();
    }

    onDropdownClick(e) {
        e.preventDefault();
        const id = e.target.dataset.id;
        this.markAsRead(id);
        const url = '/corlytics-updates?id=' + id;
        const win = window.open(url, '_blank');
        win.focus();

        // this.setState({ open: false }, () => {
        //     if (url) {
        //         if (url === 'login') AuthService.logout();
        //         this.props.history.push('/' + url);
        //     }
        // });
    }

    onDropdownClickKeyup(e) {
        if (e.keyCode === 13) this.onDropdownClick(e);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeDropdown)
    }

    formatDate(date) {
        if (!date || !date.length) return '';
        return moment(date).format(store.get('CorlyticsSession').dateFmt);
    }

    render() {
        const unread_count = this.state.notifications.filter(not => !not.seen).length;

        return (
            <div className={'global-notifications' + (this.state.open ? ' open' : '')}>
                <i className="fa fa-bell open-notifications" id="notifications-ttip" onClick={this.toggle} tabIndex="0" onKeyUp={this.toggleKeyup}></i>
                <UncontrolledTooltip placement="top" target={'notifications-ttip'} >Corlytics Updates</UncontrolledTooltip>
                {unread_count > 0 && <div class="txt open-notifications">{unread_count}</div>}
                <div className="global-notifications-dropdown">
                    <div className="global-notifications-dropdown-title small-caps">Corlytics Updates</div>
                    {this.state.notifications.length === 0 &&
                        <div className="global-notifications-dropdown-noitem" >No New Corlytics Updates</div>
                    }
                    {this.state.notifications.map(notification => {
                        return (
                            <div
                                className="global-notifications-dropdown-item"
                                style={{ fontWeight: !notification.seen ? '800' : '' }}
                                data-id={notification.id}
                                onClick={this.onDropdownClick}
                                tabIndex="0"
                                onKeyUp={this.onDropdownClickKeyup}
                            >
                                <div data-id={notification.id} style={{ fontSize: '10px' }}>{this.formatDate(notification.publication_date)}</div>
                                {notification.high_priority && <i className="fa fa-exclamation" style={{ color: '#bd2e2a' }}></i>}
                                {notification.title}
                            </div>
                        )
                    })}

                </div>
                {this.state.notifications.filter(notification => !notification.seen && notification.high_priority).map(notification => {
                    return (
                        <ModalPopup
                            title={notification.title}
                            width="700"
                            open={!notification.seen}
                            loaded={true}
                            body={<div className="col-12"><div className="notification-content">{Parser(notification.notification)}</div></div>}
                            buttonConfirm={null}
                            buttonCancel="Close"
                            confirm={null}
                            cancel={(x) => {
                                notification.seen = true;
                                this.markAsRead(notification.id);
                            }}
                        />
                    )
                })}
            </div>
        )
    }
}

export default Notifications;


// WEBPACK FOOTER //
// ./src/components/Header/Notifications.js